<template>
	<v-dialog :value="value" @input="$emit('input', $event)" max-width="600" persistent>
		<v-card>
			<v-card-title>Nuova segnalazione</v-card-title>
			<v-divider></v-divider>
			<v-card-text class="pt-4">
				<v-text-field
					v-model="title"
					label="Titolo *"
					outlined
					dense
					counter="255"
					maxlength="255"
					:error-messages="formErrors.title"
				></v-text-field>
				<v-textarea
					v-model="description"
					label="Descrizione"
					outlined
					rows="5"
					auto-grow
					hint="Descrivi il problema o la richiesta nel dettaglio."
					persistent-hint
				></v-textarea>
				<v-file-input
					v-model="files"
					label="Allegati (screenshot, file)"
					multiple
					outlined
					dense
					small-chips
					prepend-icon="mdi-paperclip"
					class="mt-3"
				></v-file-input>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text @click="close" :disabled="saving">Annulla</v-btn>
				<v-btn color="primary" :loading="saving" :disabled="!title.trim()" @click="submit">Invia</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'PortalReportDialog',
	props: {
		value: { type: Boolean, default: false },
		projectId: { type: [String, Number], required: true }
	},
	data() {
		return {
			title: '',
			description: '',
			files: [],
			saving: false,
			formErrors: {}
		}
	},
	watch: {
		value(v) {
			if (v) this.reset()
		}
	},
	methods: {
		reset() {
			this.title = ''
			this.description = ''
			this.files = []
			this.formErrors = {}
		},
		close() {
			this.$emit('input', false)
		},
		async submit() {
			const title = this.title.trim()
			if (!title) {
				this.formErrors = { title: 'Il titolo è obbligatorio' }
				return
			}
			this.saving = true
			try {
				const formData = new FormData()
				formData.append('title', title)
				if (this.description) formData.append('description', this.description)
				;(this.files || []).forEach(f => formData.append('files[]', f))
				const resp = await this.axios.post('portal/projects/' + this.projectId + '/items', formData, {
					headers: { 'Content-Type': 'multipart/form-data' }
				})
				if (resp.data.success) {
					this.$emit('created', resp.data.data)
					this.close()
				}
			} catch (e) {
				this.$store.commit('setSnackbarError')
			} finally {
				this.saving = false
			}
		}
	}
}
</script>
